<template>
  <Button
    color="text-primary"
    :title="$t('Download report')"
    :icon-btn="true"
    :icon-with-background="true"
    small
    class="ma-1"
    @click="$emit('click')"
  >
    <v-icon
      size="small"
      color="primary"
    >
      mdi-file-download-outline
    </v-icon>
  </Button>
</template>

<script setup lang="ts">
import Button from "@/components/input-components/Button.vue";

defineOptions({ name: "OrderGridActionReportDownload" });

const emit = defineEmits(['click']);
</script>

<style scoped>
</style>
